import { Container, Grid } from "@mui/material";
import React from "react";
import { Heading, P, SectionHeading, SectionSubHeading, SectionWrapper, } from "../../../Styles/style";
import fssimg from "../../../../assets/images/aboutimg.png"
import styled from "@emotion/styled";

import Dex from "../../../../assets/images/dex.png"
import Eth from "../../../../assets/images/eth.png"
import Uni from "../../../../assets/images/uni.png"
const FssImage = styled.img`
  width:100%;
  max-width: ${(props) => (props.mw ? props.mw : "550px")};
  @media screen and (max-width:599px){
  
  }
`
const WrapperGrid = styled(Grid)`
  padding: 50px 0;
  
`
const LimksGroup = styled.div`
background-color:#000;
/* margin: -8px 0px 0 0; */
padding: 20px 0px;
display:flex;
align-items:"center";
justify-content:center;
@media screen and (max-width:599px){
  padding: 0px 0px 30px;
}
`
const EthImg = styled.img`
  width: 100%;
  height:auto;
  max-width: 200px;
  margin:0 20px;
  @media screen and (max-width:699px){
    margin:0 10px;
    max-width: 85px;

  }
`
const Index = () => {
  return (
    <div>
      <LimksGroup>
        <a href="https://www.dextools.io/app/en/ether/pair-explorer/0x8e97e6cb13da296fe950edb40988296a7b862d7d" target="blank" data-aos="fade-zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="300"
          data-aos-offset="0"
          data-aos-duration="500"><EthImg src={Dex} /> </a>
        <a href="https://etherscan.io/address/0x06acd2fbbdf6e6a95415f0199b265caf3da9e3dd" target="blank" data-aos="fade-zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="400"
          data-aos-offset="0"
          data-aos-duration="500"><EthImg src={Eth} /> </a>
        <a href="https://app.uniswap.org/#/swap?chainId=1&outputCurrency=0x06Acd2fbBDF6E6a95415f0199b265caF3dA9E3DD" target="blank" data-aos="fade-zoom-in"
          data-aos-easing="ease-in"
          data-aos-delay="500"
          data-aos-offset="0"
          data-aos-duration="500"><EthImg src={Uni} /> </a>
      </LimksGroup>
      <SectionWrapper bgColor="#D2D2D2" p599="0" p="1rem 0" id="about">
        <Container maxWidth="xl">
          <WrapperGrid container>
            <Grid item xs={12} md={6}>
              <SectionSubHeading data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="200"
                data-aos-offset="0"
                data-aos-duration="500">About</SectionSubHeading>
              <SectionHeading fs1399="60PX" p599="10PX 0" fs="80px" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="500">Who is PehPeh ペペ!</SectionHeading>
              <Heading data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-offset="0"
                data-aos-duration="500">Once upon a time,</Heading>
              <P maxWidth="90%" m="10px 0 50px 0" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-offset="0"
                data-aos-duration="500">
                  In the vast realm of the cryptocurrency market, where countless tokens compete for attention, a meme coin emerged, embodying the spirit of honor and valor. PehPeh ペペ, the heroic twin brother of PEPE, the iconic frog meme, possessed extraordinary samurai skills that made him a formidable ally in the battle against rival meme tokens. Hailing from the land of the rising sun, PehPeh ペペ wielded his katana with precision, slashing through the ranks of deceitful tokens that threatened the meme community. With unwavering determination, PehPeh ペペ stood by his brother's side, ready to defend PEPE against any adversities that came their way. Together, they formed an unbreakable bond, forging a path of resilience and resilience, inspiring meme enthusiasts to rally behind them in their noble cause. Peh-Peh's samurai skills and unwavering loyalty became a symbol of hope in the world of cryptocurrencies, reminding everyone that even in the digital realm, heroes could emerge to protect what they hold dear.
                </P>
            </Grid>
            <Grid item xs={12} md={6}
textAlign="center"
              alignSelf="self-end"
            data-aos="zoom-in"
            data-aos-easing="ease-in"
            data-aos-delay="600"
            data-aos-offset="0"
              data-aos-duration="500"><FssImage src={fssimg} /></Grid>
        </WrapperGrid>

      </Container>
    </SectionWrapper>
    </div >
  );
};

export default Index;
